import React, { useEffect, useRef, useState } from 'react';
import { usePrefersReducedMotion } from '@/lib/hooks';

export const Counter = ({ value, suffix = '', duration = 1600, className = '' }) => {
  const numeric = parseInt(String(value).replace(/[^0-9]/g, ''), 10);
  const isNumeric = !Number.isNaN(numeric);
  const [display, setDisplay] = useState(isNumeric ? 0 : value);
  const ref = useRef(null);
  const started = useRef(false);
  const reduced = usePrefersReducedMotion();

  useEffect(() => {
    if (!isNumeric) {
      setDisplay(value);
      return;
    }
    if (reduced) {
      setDisplay(numeric);
      return;
    }
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !started.current) {
            started.current = true;
            const start = performance.now();
            const tick = (now) => {
              const p = Math.min((now - start) / duration, 1);
              const eased = 1 - Math.pow(1 - p, 3);
              setDisplay(Math.round(eased * numeric));
              if (p < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          }
        });
      },
      { threshold: 0.4 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [numeric, isNumeric, duration, reduced, value]);

  return (
    <span ref={ref} className={className}>
      {display}
      {suffix}
    </span>
  );
};
